import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../Context/CartContext";
import { usePincode } from "../Context/PincodeContext";
import { useWishlist } from "../Context/WishlistContext";
import { useState } from "react";
import CategoryNav from "./CategoryNav";
import { products } from "../data/products";

export default function Header() {
  const { cart } = useCart();
  const { pincode, setPincode } = usePincode();
  const { wishlistIds } = useWishlist();
  const count = cart.reduce((s, i) => s + i.quantity, 0);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);

  const query = search.trim().toLowerCase();
  const suggestions =
    query.length >= 3
      ? products
          .filter((p) => p.name.toLowerCase().includes(query))
          .slice(0, 6)
      : [];

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (search.trim()) {
      navigate(`/shop?q=${encodeURIComponent(search)}`);
      setShowSuggestions(false);
    }
  }

  const handleSuggestionClick = (id: string) => {
    setSearch("");
    setShowSuggestions(false);
    navigate(`/product/${id}`);
  }

  const handlePincodeClick = () => {
    const code = prompt("Enter your 6-digit Pincode to see estimated delivery dates:");
    if (code && code.trim().length >= 4) {
      setPincode(code.trim());
    }
  }

  return (
    <>
    <header className="header">
      <h2 className="logo">Bloomora Naturals</h2>
      
      <div style={{ position: 'relative' }}>
        <form onSubmit={handleSearch} style={{ display: 'flex', gap: '8px' }}>
          <input
            type="text"
            placeholder="Search items..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onFocus={() => setShowSuggestions(true)}
            onBlur={() => setShowSuggestions(false)}
            onKeyDown={(e) => {
              if (e.key === 'Escape') setShowSuggestions(false);
            }}
            style={{ padding: '6px', borderRadius: '4px', border: '1px solid #ccc', width: '240px' }}
          />
          <button type="submit" style={{ padding: '6px 12px', borderRadius: '4px', border: '1px solid #ccc', background: '#fff', cursor: 'pointer' }}>Search</button>
        </form>

        {query.length >= 3 && showSuggestions && suggestions.length > 0 && (
          <div
            style={{
              position: 'absolute',
              top: 'calc(100% + 4px)',
              left: 0,
              right: 0,
              background: '#fff',
              border: '1px solid var(--border)',
              borderRadius: 'var(--radius-sm)',
              boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
              zIndex: 1000,
              overflow: 'hidden',
            }}
          >
            {suggestions.map((p) => (
              <div
                key={p.id}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => handleSuggestionClick(p.id)}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '8px 12px',
                  cursor: 'pointer',
                  fontSize: '14px',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--bg)')}
                onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
              >
                <span>{p.name}</span>
                <span style={{ color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>₹{p.price}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      <nav>
        <Link to="/">Home</Link>
        <Link to="/shop">Shop</Link>
        <Link to="/wishlist" style={{ display: 'flex', alignItems: 'center', gap: '0px' }} aria-label="Wishlist">
          <span style={{ fontSize: '18px', lineHeight: 1 }}>♡</span>
          <span style={{
            minWidth: '16px',
            height: '16px',
            marginLeft: '-2px',
            padding: '0 4px',
            borderRadius: '8px',
            background: '#d00000',
            color: '#fff',
            fontSize: '11px',
            lineHeight: '16px',
            textAlign: 'center',
            fontWeight: 'bold',
          }}>{wishlistIds.length}</span>
        </Link>
        <Link to="/cart" style={{ display: 'flex', alignItems: 'center', gap: '0px' }} aria-label="Cart">
          <span style={{ fontSize: '18px', lineHeight: 1 }}>🛒</span>
          <span style={{
            minWidth: '16px',
            height: '16px',
            marginLeft: '-2px',
            padding: '0 4px',
            borderRadius: '8px',
            background: '#d00000',
            color: '#fff',
            fontSize: '11px',
            lineHeight: '16px',
            textAlign: 'center',
            fontWeight: 'bold',
          }}>{count}</span>
        </Link>
        
        <div style={{ cursor: 'pointer', fontWeight: 600, color: 'var(--link)' }} onClick={handlePincodeClick}>
          📍 {pincode ? `Deliver to ${pincode}` : "Select Location"}
        </div>
        <div
          className="profile-menu"
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        >
          <span className="profile-link">Profile ▾</span>

          {open && (
            <div className="dropdown">
              <Link to="/profile/orders">Orders</Link>
              <div style={{ borderTop: '1px solid var(--border)', margin: '4px 0' }}></div>
              <Link to="/admin/add-product" style={{ color: '#d00000', fontWeight: 'bold' }}>Admin Panel</Link>
            </div>
          )}
        </div>
      </nav>
    </header>
    <CategoryNav />
    </>
  );
}
